export const locale = {
  lang: 'zh2',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': '我的简历',
      'ENLACES': {
        'configuracion': '帐号设定',
        'notificaciones': '用户通知',
        'mensajes': '收到的消息'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': '帐号设定',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': '更改电子邮件',
              'SUBTITULO': '您可以更改帐户的电子邮件地址',
              'INPUTS': {
                'MAIL': '新的电子邮件地址',
                'TOKEN': '验证码',
                'PASS': '新密码',
                'CONFIRMPASS': '确认密码'
              },
              'BOTONES': {
                'CAMBIAMAIL': '更改电子邮件',
                'VERTOKEN': '校验码',
                'FINALMAIL': '更改电子邮件地址',
              }
            },
            'CAMBIARPASS': {
              'TITULO': '更改密码',
              'SUBTITULO': '您可以更改您的帐户密码',
              'BOTONES': {
                'FINALPASS': '更改密码'
              }
            },
            'AUTENTICACION': {
              'TITULO': '两步验证',
              'SUBTITULO': '您可以通过激活两步验证来提高帐户的安全性',
              'BOTONES': {
                'ACTIVAR': '启用',
                'DESACTIVAR': '停用'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': '一条带有验证码的消息已发送到指定的电子邮件，请输入收到的验证码以继续该过程',
        'CAMBIARMAIL_PASO1_NOTOK': '无法继续，输入的邮箱已在系统中注册',
        'CAMBIARMAIL_PASO1_SAME': '无法继续，输入的电子邮件与当前帐户相同',
        'CAMBIARMAIL_PASO2_OK': '验证码正确，要继续，您需要在下方输入新密码',
        'CAMBIARMAIL_PASO2_NOTOK': '验证码不正确，请检查您输入的是否正确，然后再次检查',
        'CAMBIARMAIL_PASO3_NOTOK': '无法继续，密码不匹配，请重新正确输入',
        'CAMBIARMAIL_PASO3_OK': '帐户数据已正确更新，为完成会话将关闭的过程，使用新的访问数据重新进入平台',
        'CAMBIAPASS_OK': '账号密码更新成功',
        'CAMBIAPASS_NOTOK': '无法继续，密码不匹配，请重新正确输入',
        'AUTHOK': '认证状态更新成功'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'关      ',
      'MYPROFILLE':'我的简历',
      'TITLE':'更改密码',
       'BTNBACK':'返回',
       'MENUTITLE':'菜单',
       'MENU':{
         'OPC1':'我的资料'
       },
       'NAME':'名称',
       'EMAIL':'邮件',
       'CODE':'验证码',
       'NEWPASS':'新密码',
       'REPASS':'确认密码',
       'CHANGE':'更改密码',
       'SENDCODE':'发送验证码',
       'CHECKCODE':'验证码',
       'ERROR':{
        'ERROR01':'必填項目',
        'ERROR02':'錯誤，發生了一些事',
        'ERROR03':'代碼不匹配',
        'ERROR04':'密碼不匹配',
        'ERROR05':'至少3个字符',
        'ERROR06':'该电子邮件已经存在，请尝试使用另一封电子邮件',
        'ERROR07':'公司名称不符'
      },
      'SUCCESS':{
        'OK':'Ok',
       'MESESAGE1':'數據正確更新',
       'MESESAGE2':'驗證碼已發送...請檢查您的電子郵件',
       'MESESAGE3':'正確的代碼'
      }

    },
  }
};
